import { cva } from "class-variance-authority";

export { default as Button } from "./Button.vue";

export const buttonVariants = cva(
    "inline-flex items-center justify-center rounded-lg text-sm font-medium ring-offset-white transition-colors transition-[width] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stone-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 dark:ring-offset-stone-950 dark:focus-visible:ring-stone-300 duration-150",
    {
        variants: {
            variant: {
                default:
                    "bg-stone-900 text-stone-50 hover:bg-stone-900/90 dark:bg-stone-50 dark:text-stone-900 dark:hover:bg-stone-50/90",
                destructive: "bg-error-600 hover:bg-error-700 text-white",
                "destructive-ghost":
                    "text-error-600 bg-white  hover:text-error-700",
                outline:
                    "border border-iron-300 text-iron-600 bg-white shadow-xs hover:bg-iron-50 hover:text-iron-700",
                secondary:
                    "bg-stone-100 text-stone-900 hover:bg-stone-100/80 dark:bg-stone-800 dark:text-stone-50 dark:hover:bg-stone-800/80",
                ghost: "text-z-primary-600 !h-auto !py-[2px] !p-0 !m-0 hover:text-z-primary-700 dark:hover:bg-stone-800 dark:hover:text-stone-50 ",
                link: "text-stone-900 underline-offset-4 hover:underline dark:text-stone-50",
            },
            size: {
                default: "h-10 px-4 py-2",
                sm: "h-9 rounded-lg px-3",
                lg: "h-11 rounded-lg px-8",
                icon: "h-10 w-10",
                xs: "py-[2px]",
            },
        },
        defaultVariants: {
            variant: "default",
            size: "default",
        },
    },
);
